import React from "react";

import { IonButton, IonRouterLink } from "@ionic/react";

import "./Button.scss";

const ButtonLink = (props: any) => {
  const { to, ...buttonProps } = props;

  return (
    <IonRouterLink routerLink={to}>
      <IonButton expand="block" {...buttonProps}>
        {props.text || props.children}
      </IonButton>
    </IonRouterLink>
  );
};

export default ButtonLink;
